import { create } from 'zustand'

export const useAiChatStore = create((set) => ({
  open: false,
  pendingQuestion: null,
  openChat: () => set({ open: true }),
  closeChat: () => set({ open: false, pendingQuestion: null }),
  toggleChat: () => set((s) => ({ open: !s.open })),
  askChat: (q) => set({ open: true, pendingQuestion: q }),
  consumePending: () => set({ pendingQuestion: null }),
}))
